<div class="person-owner-container">
  <c11n-dropdown
    id="person-owner-dropdown"
    [labelText]="accountDetailsContent.ACCOUNT_DETAILS_INDIVIDUAL_NAME"
    [menuData]="ownerOptions"
    [activeItems]="selectedOwnerId ? [selectedOwnerId] : []"
    [placeholderText]="'Select an owner'"
    (stateChange)="onOwnerSelectionChange($event)"
    (focusout)="validateOwnerSelectionOnBlur()"
  >
  </c11n-dropdown>
  <c11n-hint-error
    [hasError]="hasInteracted && !validOwnerSelection"
    [size]="'medium'"
    [errorText]="accountDetailsContent.ACCOUNT_DETAILS_OWNER_ERROR"
    hintErrorId="person-owner-error"
  >
  </c11n-hint-error>
</div>
